
export enum IAudioStatus {
    NotConnected = "NOT_CONNECTED",
    Connecting = "CONNECTING",
    Connected = "CONNECTED",
    Muted = "MUTED"
}

export interface IAudioEvent {
    eventName?: string,
    uid: string|number
}

export default interface IAudioUser{
    uid: number | string,
    
}